module.exports = __webpack_public_path__ + "bcda45d707013db98fea3e301d9141d9.png";